export function filteredBookings( state ) {
    let keyTab = state.tabSelected
    const dataTab = state.tabs.find( item => item.key === keyTab)
    return dataTab.dingusBookings || []
}